module.exports = __webpack_public_path__ + "static/media/hair (5).7854e223.jpg";